export default {"src":"/encomendas-static/_next/static/media/googlePlay.adf83fe7.svg","height":32,"width":108,"blurWidth":0,"blurHeight":0};